import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const MapMarkerIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M12 20.98C6.24 14.96 5.32 13 5.32 10.34C5.32 6.76 8.38 3.72 12 3.72C15.62 3.72 18.68 6.76 18.68 10.34C18.68 13 17.76 14.96 12 20.98ZM12 5.44C9.28 5.44 7.04 7.66 7.04 10.36C7.04 12.28 7.62 13.72 12 18.56C16.38 13.72 16.96 12.28 16.96 10.36C16.96 7.66 14.72 5.44 12 5.44ZM12 12.78C10.64 12.78 9.54 11.68 9.54 10.32C9.54 8.96 10.64 7.86 12 7.86C13.36 7.86 14.46 8.96 14.46 10.32C14.46 11.68 13.36 12.78 12 12.78Z" />
    </SvgIcon>
  );
});
